import { CustomDropdown } from 'components/shared/CustomDropdown';
import { HelperConstant } from '../../helpers/HelperConstant';
import { isRider } from '../../helpers/TokenHelper';
import { IGetOrderSummaryModel } from 'models/GetOrderSummary.Model';
import { IOrderRejectModel } from 'models/OrderReject.Model';
import React, { useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form';
import { Col, Form, FormFeedback, Row } from 'reactstrap';
import CommonService from 'services/CommonService';
import { CustomAmount } from 'components/shared/CustomAmount';
import { isIn } from '../../helpers/Helper';
import { CustomTextBox } from 'components/shared/CustomTextBox';
import { CustomButton } from 'components/shared/CustomButton';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { values } from 'lodash';
import { IOrderReturnModel } from 'models/OrderReturnModel';
import CustomLoader from 'components/Common/CustomLoader';
import { useNavigate } from 'react-router-dom';

type props = {
    orderSummaryData?: IGetOrderSummaryModel,
    setShowModal?: any,
    isCancel?: boolean,
    encryptedOrderId: any
};

function ResendToCustomer({ setShowModal, orderSummaryData, isCancel, encryptedOrderId }: props) {
    const riderlogin: boolean = isRider() ?? false;
    let navigate = useNavigate();
    const { formState: { errors } } = useForm<IOrderReturnModel>();

    const [section, setSection] = useState<Array<any>>([]);
    const [loading, setLoading] = useState(false);

    const validation: any = useFormik<IOrderReturnModel>({

        enableReinitialize: true,
        initialValues: {
            id: 0,
            created: '',
            createdBy: 0,
            active: true,
            modified: '',
            modifiedBy: 0,
            validationErrors: '',
            orderId: 0,
            comments: '',
            // reason: 0
        },
        validationSchema: Yup.object().shape({
            comments: Yup.string().required("Please Enter Your comments"),
            // reason: Yup.string().notOneOf(['0'], 'Please Select Your Reason').required("Please Select Your Reason"),
        }),

        onSubmit(values: any) {
            setLoading(true);
            const Data = {
                id: 0,
                created: "",
                createdBy: 0,
                active: true,
                modified: "",
                modifiedBy: 0,
                validationErrors: "",
                orderId: 0,
                comments: values.comments,
                // reason: parseInt(values.reason)
            };
            CommonService.postWithEntityandSingleQueryParam("Sell", "ReturnOrder", Data, "encryptedOrderId", encryptedOrderId).then(res => {
                setLoading(false);
                if (res.status === 200) {
                    localStorage.setItem("returnRedirect", "true");
                    window.location.replace("/homepage");
                    setShowModal(false);
                }
            }).catch(e => {
                console.log(e);
            })
        },

    });

    useEffect(() => {
        CommonService.getWithQueryParam("master", "GetAllFailureType", 'serviceTypeId', HelperConstant.serviceTypeId.SELL).then(response => {
            if (response.status === 200) {
                setSection(response.data);
            }
        }).catch(e => {
            if (e == 'Request failed with status code 401') {
                navigate('/logout')
            } else {
                console.error("API error:", e);
            }
        })

    }, [])


    return (
        <React.Fragment>
            <Row className='m-2'>
                <Col xl={12} className=''>
                    <div className='d-flex justify-content-between'>
                        <p className='font-size-16 fw-semibold text-dofy'>Return Order</p>
                        <i className='mdi mdi-close align-top font-size-16 cursor-pointer' onClick={() => setShowModal(false)}></i>
                    </div>
                    <div>
                        <span className='text-dofy font-size-14'>Order Id: </span>
                        <span className='text-dofy font-size-15 fw-semibold'>{orderSummaryData?.OrderCode}</span>
                    </div>
                    <div>
                        <Form className="form-horizontal"
                            onSubmit={(e) => {
                                e.preventDefault();
                                validation.handleSubmit();
                                return false;
                            }}
                        >
                            <CustomLoader isOpen={loading} />
                            <p className='text-muted fw-semibold font-size-14 my-1'> Are you sure to Returned this order to Customer ?</p>
                            {/* <CustomDropdown isMandatory={true} label={'Reason'} name={'reason'} id={'reason'} value={validation?.value?.reason} data={section} error={validation.errors.reason} displayField='Name' valueField='Id'
                                onChange={validation?.handleChange}
                                onBlur={validation?.handleBlur}
                                invalid={validation?.touched?.reason && validation?.errors?.reason ? true : false}
                            />
                            {validation?.touched?.reason && validation?.errors?.reason ? (
                                <FormFeedback type="invalid">{validation?.errors?.reason}</FormFeedback>
                            ) : null} */}
                            <div className='my-1 mt-1'>
                                <CustomTextBox label={'Comments'} id={'comments'} value={validation?.value?.comments} error={undefined} onChange={validation?.handleChange} onBlur={validation?.handleBlur} isMandatory={true}
                                    invalid={validation?.touched?.comments && validation?.errors?.comments ? true : false} />
                                {validation?.touched?.comments && validation?.errors?.comments ? (
                                    <FormFeedback type="invalid">{validation?.errors?.comments}</FormFeedback>
                                ) : null}
                            </div>
                            <div className='d-flex justify-content-end my-2'>
                                <CustomButton type={'button'} btnClassName={'btn-light me-2'} iconClasssName={'mdi mdi-close'} name={''} onClick={() => setShowModal(false)} />
                                <CustomButton type={'submit'} btnClassName={'btn-success'} iconClasssName={undefined} name={'Return Order'} disabled={false} />
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default ResendToCustomer
